import * as htmlToImage from 'html-to-image';
import { useEffect, useRef, useState } from 'react';
import Efct8 from '../../../acets/efectsfilters/8.png'
import { useFont } from '../../../ContextFont';
import Advogado from'../../../acets/adv.jpg'
import IcoEdit from'../../../acets/icon/edit.svg'

export default function Lay03(props) {
  const divRef = useRef(null);
  const { fonte, alterarFonte, imagens, adicionarImagem, handleDownloadImage } = useFont();
  //console.log(props)
  const [titulo, setTitulo]=useState(props.datal.titulo)
  const [subtitulo,setSubtitulo]=useState(props.datal.subtitulo)
  const [modalData, setModaldata]=useState(false)
  const [numimg,setNumimg]=useState(2)
  const [cor, setCor] = useState(`${props.trapColor}${props.inclinacao}`);
  useEffect(() => {
    // Atualiza os estados locais quando props.datal é alterado
    setTitulo(props.datal.titulo);
    setSubtitulo(props.datal.subtitulo);
    setCor(`${props.trapColor}${props.inclinacao}`);
  }, [props.datal,props.trapColor, props.inclinacao]); 
  return (
    <div className='w33 cell-tamanho90 center celular b2 cont-circ7 bordaElements ma10b0'>
      <div className='p10 b2 w5 cont-circ50pc fb'>3</div>
      <div ref={divRef} id="resultImg03" className="w100 h40 column between cell-tamanho">
        <div className='w100 h40 column center cell-tamanho ' style={{ backgroundImage: `url(${imagens.length > 0 ? imagens[numimg].urls.small : Advogado})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}>
          <div className=" h40 w100 column center cell-tamanho fundo-opaco-login bordaElements" style={{ backgroundImage: `url('${Efct8}')`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat',backgroundPosition:'center'}} >
          
          <div className='w90 row'>
            <div className='50 column center'>
              <h2 style={{ fontSize: `${props.titlesize / .2}px`, color: props.trapColor }} className='z4 fb' >3</h2>
            </div>
            <div className='w60 h20 column center'>
              <label className='z4 w100 fs2em fb p10 cont-circ7' style={{ fontSize: `${props.titlesize}px`, color: props.textColor ,background: cor}}>Super Dicas</label>
             
            </div>
            <label className='w100 cen fw500 z4 fs06em' style={{ color: props.textColor }}>Texto na legenda</label>
            <div className='b3 w90 column center cont-circ7 p7 ma10b0 sombra-small' >
              <label className='fw500 z4 ' style={{ fontSize: `${props.subtitlesize * 0.7}px`,color: props.trapColor }}>{props.datav.instagram}</label>
            </div>
            </div>
            { modalData&&
            <div className='posiabste b2 h30 z16 w17 p10 cell-tamanho-metade55 bordaElements'>
             
              <div className='w100 row between'>
                 <label className=''>Titulo</label>
                <img src='https://cdn-icons-png.flaticon.com/128/70/70287.png' className='pp w10' onClick={() => setModaldata(!modalData)}/>
              </div>
              <input type='text' value={titulo} onChange={(e)=>setTitulo(e.target.value)}/>
              <label>Subtitulo</label>
              <input type='text' value={subtitulo} onChange={(e)=>setSubtitulo(e.target.value)}/>
            </div>
            }
          </div>
        </div>

        
      </div>
      <div className="w100 he20 overflowY">
          <div className="w100 row between ma5">
            <div className="row w50">
              <img src='https://cdn-icons-png.flaticon.com/128/535/535285.png' className='w15 ml5' alt='plus / mais' />
              <img src='https://cdn-icons-png.flaticon.com/128/5948/5948565.png' className='w15 ml5' alt='plus / mais' />
              <img src='https://cdn-icons-png.flaticon.com/128/5728/5728145.png' className='w15 ml5' alt='plus / mais' />
            </div>
            <div className="w50 row between">
              
            </div>
          </div>
          <label className="fs08em ">{props.datal.legenda}</label>
          <div>
            <label className="w100 fs08em fw500">{props.datal.hashtag}</label>
          </div>
        </div>

        <div className='w100 row between'> 
        <div className='h5 w30 fs08em cont-circ8 pp b2 row center  m10 c4' 
            onClick={() => setNumimg(numimg >= 9 ? 0 : numimg + 1)}>
              Imagem
              <img src='https://cdn-icons-png.flaticon.com/128/1829/1829415.png' alt='IcoEdit' className='w17 m10'/>
            </div>
        <div 
            className='w30 h5 fs08em cont-circ8 pp b2 row center  m10 c4'
            onClick={() => setModaldata(!modalData)}>
            {modalData ? "Fech." : "Texto"}
            <img src={IcoEdit} alt='IcoEdit' className='w25'/>
        </div>
        <div 
          className="w30 h5 fs08em cont-circ8 pp b2 row center  m10 c4" 
          onClick={() => handleDownloadImage('resultImg03')}>
            Baixar
          <img src='https://cdn-icons-png.flaticon.com/128/5191/5191992.png' alt='IcoEdit' className='w17 m10'/>
        </div>
      </div> 
    </div>
  )
}